import { setCookie } from "@insite/client-framework/Common/Cookies";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import React, { FC } from "react";
import { css } from "styled-components";

interface Props {
    pagination: {
        totalItemCount: number;
        page: number;
        pageSize: number;
        pageSizeOptions: number[];
    };
    addProductFilters: (filters: { page?: number; pageSize?: number }) => void;
}

/* ---------------------------------------------
   STYLES (Mobius way)
---------------------------------------------- */
interface CustomPaginationStyles {
    pagination?: PaginationPresentationProps;
}

const customPaginationStyles: CustomPaginationStyles = {
pagination: {
    cssOverrides: {
        pagination: css`
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            @media (max-width: 1279px) {
                width: 100%;
                flex-direction: column; 
                justify-content: center;
            }
        `,

        /* LEFT: Results per page */
        perPageSelect: css`
            display: flex;
            align-items: center;

            /* Override Mobius FormField layout */
            label {
                text-align: left !important;
            }
        `,

        /* RIGHT: Page numbers (pseudo-center) */
        linkList: css`
            display: flex;
            transform: translateX(-50%);

            ul {
                display: flex;
                align-items: center;
            }

                /* MOBILE FIX */
            @media (max-width: 1279px) {
                transform: none;
                width: auto;
                justify-content: center;
            }
        `,
    },
},
};

const styles = customPaginationStyles;

/* ---------------------------------------------
   COMPONENT
---------------------------------------------- */
const ProductListPagination: FC<Props> = ({ pagination, addProductFilters }) => {
    if (!pagination || !pagination.totalItemCount) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        addProductFilters({ page: newPageIndex });

        setTimeout(() => {
            if (typeof window !== "undefined") {
                window.scrollTo({
                    top: window.innerWidth < 768 ? 150 : 0,
                    behavior: "auto",
                });
            }
        }, 100);
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        addProductFilters({ pageSize: newPageSize });
        setCookie("ProductList-PageSize", newPageSize.toString());
    };

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={pagination.totalItemCount}
            currentPage={pagination.page}
            resultsPerPage={pagination.pageSize}
            resultsPerPageOptions={pagination.pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            pageSizeCookie="ProductList-PageSize"
        />
    );
};

export default ProductListPagination;